<template>
  <div>
    <v-dialog v-model="showDeleteMap" max-width="290">
      <v-card>
        <v-card-title class="headline">Confirm Delete</v-card-title>
        <v-card-text>
          <strong>Are you sure you want to delete this map?</strong>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="showDeleteMap = false">Cancel</v-btn>
          <v-spacer />
          <v-btn color="red" text :loading="loading" @click="removeMap"
            >Yes, Proceed</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="show" max-width="900" scrollable @click:outside="close">
      <v-card v-if="site">
        <v-card-title class="headline">Site Map</v-card-title>

        <v-card-text>
          <v-carousel
            hide-delimiters
            :show-arrows="site.site_map.length > 1"
            v-if="site.site_map.length > 0"
            @change="getCurrentMap"
          >
            <v-carousel-item
              v-for="(map, i) in site.site_map"
              :key="i"
              reverse-transition="fade-transition"
              transition="fade-transition"
            >
              <div class="delete-btn" @click="showDeleteMap = true">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn fab color="lightgrey" x-small v-on="on">
                      <v-icon>{{ icons.delete }}</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Map</span>
                </v-tooltip>
              </div>
              <v-img :src="map.url" alt="Photos" height="500" contain />
            </v-carousel-item>
          </v-carousel>

          <div v-else>
            No maps uploaded for this site yet.
          </div>

          <div class="d-flex mt-4">
            <v-file-input
              v-model="files"
              single-line
              flat
              outlined
              dense
              small-chips
              multiple
              prepend-icon
              placeholder="Click here to select new images"
              hide-details
              accept="image/*"
              :error-messages="form.$getError('files')"
              @change="loadAttachments"
              @click.clear="loadAttachments"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip v-if="index < 4" label small>{{ text }}</v-chip>

                <span
                  v-else-if="index === 4"
                  class="overline grey--text text--darken-3 mx-2"
                  >+{{ files.length - 4 }} photo(s)</span
                >
              </template>
            </v-file-input>
            <v-btn
              color="primary"
              class="ml-3"
              depressed
              height="40px"
              :disabled="files.length === 0"
              :loading="loading"
              @click="uploadPhotos"
            >
              UPLOAD
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mdiPlus, mdiClose } from '@mdi/js'
import Form from '@/utils/form'
import Compressor from 'compressorjs'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      site: state => state.site.siteDetails
    })
  },

  data() {
    return {
      loading: false,
      form: new Form({
        id: null,
        files: []
      }),
      files: [],
      show: this.value,
      showDeleteMap: false,
      currentMapId: null,
      icons: {
        upload: mdiPlus,
        delete: mdiClose
      }
    }
  },

  methods: {
    ...mapActions({
      uploadSiteMap: 'site/uploadSiteMap',
      deleteSiteMap: 'site/deleteSiteMap'
    }),

    close() {
      this.$emit('closeModal')
      this.show = false
    },

    loadAttachments() {
      let _this = this
      this.form.files = []
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = e => {
          const base64Img = e.target.result
          const binaryImg = this.convertDataURIToBinary(base64Img)
          const blob = new Blob([binaryImg], { type: file.type })

          // eslint-disable-next-line
          new Compressor(blob, {
            quality: 0.5,
            success(result) {
              _this.addCompressedImage(result)
            }
          })
        }
      }
      this.isChanged = true
    },

    addCompressedImage(result) {
      this.form.files.push(result)
    },

    convertDataURIToBinary(dataURI) {
      const BASE64_MARKER = ';base64,'
      const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
      const base64 = dataURI.substring(base64Index)
      const raw = window.atob(base64)
      const rawLength = raw.length
      var array = new Uint8Array(new ArrayBuffer(rawLength))

      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i)
      }
      return array
    },

    async uploadPhotos() {
      let data = new FormData()
      data.append('site_id', this.site.site_id)
      for (let i = 0; i < this.form.files.length; i++) {
        data.append('files[]', this.form.files[i])
      }

      this.loading = true
      await this.uploadSiteMap(data)
      this.form.files = []
      this.files = []
      this.loading = false
    },

    getCurrentMap(v) {
      this.currentMapId = this.site.site_map[v].id
    },

    async removeMap() {
      this.loading = true
      await this.deleteSiteMap({
        site_id: this.site.site_id,
        site_map_id: this.currentMapId
      })
      this.showDeleteMap = false
      this.loading = false
      this.currentMapId =
        this.site.site_map.length > 0 ? this.site.site_map[0].id : null
    }
  },

  watch: {
    value(val) {
      this.show = val
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-btn {
  position: absolute;
  z-index: 2;
  top: 15px;
  right: 15px;
}
.v-carousel {
  border: 1px solid black;
}
.v-carousel .v-window-item {
  background: black;
}
</style>
